<template>
  <div class="classify">
    <!-- 头部 -->
    <hearderCommon :text="text"></hearderCommon>
    <!-- 下拉菜单 -->
    <van-dropdown-menu
      active-color="#74B42B"
      style="color: #74b42b"
      class="class_van_drop"
    >
      <van-icon
        name="arrow-down"
        class="van_down"
        :class="ttitle.length > 4 ? 'active' : ''"
      />
      <van-icon name="search" size="24px" class="search" @click="goSearch" />
      <van-icon
        name="shopping-cart"
        size="24px"
        class="shopping-cart"
        @click="goCart"
        :badge="countCart"
      />
      <van-dropdown-item
        v-model="value"
        :options="option"
        @change="getChildrenLits"
      />
    </van-dropdown-menu>
    <!-- 侧边栏 -->
    <van-sidebar v-model="activeKey" class="cla-sidebar">
      <van-sidebar-item
        :title="index.name"
        v-for="index in childrenLits"
        :key="index.categoryId"
        @click="showCategory"
      />
    </van-sidebar>
    <div id="refresh">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <CommonList
          :List="CartList"
          style="margin-left: 85px; margin-top: 44px; z-index: 1; height: 100%"
          @count="count"
          @Guige="showGuige"
          @JiBu="JiBu(arguments)"
          @addition="addition(arguments)"
          @removeAll="removeAll(arguments)"
          @addRemark="addRemark(arguments)"
          @DanAdd="DanAdd(arguments)"
          @DanAllRem="DanAllRem(arguments)"
          @DanRem="DanRem(arguments)"
          @Dia="Dia(arguments)"
          @DiaDan="DiaDan(arguments)"
          @sPop="sPop(arguments)"
          @sPopDan="sPopDan(arguments)"
        ></CommonList>
      </van-list>
    </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import CommonList from "../common/list";
import hearderCommon from "../common/headerCommon";

export default {
  components: {
    CommonList,
    hearderCommon,
  },
  data() {
    return {
      CartList: [],
      activeKey: 0,
      value: "",
      loading: false,
      refreshing: false,
      option: [],
      finished: false,
      page: {
        current: 1,
        total: 0,
        size: 20,
      },
      classifyList: [],
      childrenLits: [],
      activeKeyId: "",
      customerId: "",
      countCart: "",
      option1: "蔬菜类",
      ttitle: "",
      text: "分类",
      isLoading: false,
    };
  },
  created() {
    // 获取客户ID
    this.customerId = localStorage.getItem("customerId");
    // 获取商品大分类
    this.$axios.post("/goods/goodsCategory/list").then((res) => {
      this.classifyList = res.data.data;
      //  获取传递过来的categoryId
      this.value = localStorage.getItem("categoryId");
      if (this.value == undefined) {
        this.value = this.$route.query.categoryId;
      }
      //  商品大的分类列表
      this.classifyList.forEach((item, index) => {
        if (this.option[index] === undefined) {
          this.option.push({ text: item.name, value: item.categoryId });
        } else {
          this.option[index].text = item.name;
          this.option[index].value = item.categoryId;
        }
      });
    });
  },
  watch: {
    // 开始显示
    value: {
      immediate: true,
      handler(val) {
        if (!val) {
          return false;
        }
        this.value = val;
        this.showOne();
        localStorage.setItem("SKIO", val);
        let txt = this.option.find((item) => item.value == val);
        if (txt == undefined) {
          return;
        }
        this.ttitle = txt.text;
        document.getElementsByClassName(
          "van-dropdown-menu__item"
        )[0].innerHTML = txt.text;
      },
    },
  },

  methods: {
    count(payload) {
      this.countCart = payload;
    },
    //下拉刷新
    onRefresh() {
      setTimeout(() => {
        this.refreshing = false;
      }, 500);
    },
    // 请求商品
    getGOODS(activeKeyId) {
      const params = {
        categoryId: activeKeyId,
        customerId: this.customerId,
      };
      this.$axios
        .post(
          `/trade/tradeOrder/search/price/page?current=${1}&size=${20}`,
          params
        )
        .then((res) => {
          this.CartList = res.data.data.records || [];
          this.CartList.forEach((item) => {
            this.$set(item, "showGuiGe", false);
            item.children.forEach((index) => {
              if (index.remark) {
                this.$set(index, "remark", index.remark);
              } else {
                this.$set(index, "remark", "");
              }
              this.$set(index, "showJiBu", false);
              this.$set(index, "showRemark", false);
              this.$set(index, "showPop", false);
              this.$set(index, "showDia", false);
              this.$set(index, "newOrderQty", index.orderQty);
              this.$set(index, "newRemark", index.remark);
            });
          });
        })
        .catch(() => {});
    },
    // 下拉加载
    onLoad() {
      this.page.current += 1;
      const params = {
        categoryId: this.activeKeyId,
        customerId: this.customerId,
      };
      if (this.finished) {
        return false
      }
      this.$axios
        .post(
          `/trade/tradeOrder/search/price/page?current=${this.page.current}&size=${this.page.size}`,
          params
        )
        .then((res) => {
          const { records = [], pages = 0 } = res.data.data
          if (pages<=this.page.current) {
            this.finished = true
          }
          this.CartList.push(...records);
          this.CartList.forEach((item) => {
            this.$set(item, "showGuiGe", false);
            item.children.forEach((index) => {
              if (index.remark) {
                this.$set(index, "remark", index.remark);
              } else {
                this.$set(index, "remark", "");
              }
              this.$set(index, "showJiBu", false);
              this.$set(index, "showRemark", false);
              this.$set(index, "showPop", false);
              this.$set(index, "showDia", false);
              this.$set(index, "newOrderQty", index.orderQty);
              this.$set(index, "newRemark", index.remark);
              this.loading = false;
            });
          });
        })
        .catch(() => {});
    },
    // 显示商品列表
    showCategory(index) {
      this.onRefresh(1);
      this.activeKeyId = this.childrenLits[index].categoryId;
      localStorage.setItem("activeKeyId", this.activeKeyId);
      this.page.current = 1;
      this.finished = false;
      this.loading= false
      this.getGOODS(this.activeKeyId);
    },
    // 显示第一个
    showOne() {
      this.$axios
        .get(`/goods/goodsCategory/children/${this.value}`)
        .then((res) => {
          this.childrenLits = res.data.data;
          this.childrenLits.forEach((item) => {
            this.$set(item, "text", item.name);
          });
          if (!this.childrenLits) {
            return (this.CartList = []);
          }
          // 获取第一个ID显示
          if (res.data.data.length > 0) {
            this.activeKeyId = this.childrenLits[0].categoryId;
          }
          let params = {
            categoryId: this.activeKeyId,
            customerId: this.customerId,
          };
          this.$axios
            .post(
              `/trade/tradeOrder/search/price/page?current=1&size=20`,
              params
            )
            .then((res) => {
              let data = res.data.data;
              if (data !== null) {
                this.CartList = data.records;
                this.page = {
                  current: data.current,
                  total: data.total,
                  size: data.size,
                };
                this.CartList.forEach((item) => {
                  this.$set(item, "showGuiGe", false);
                  item.children.forEach((index) => {
                    if (index.remark) {
                      this.$set(index, "remark", index.remark);
                    } else {
                      this.$set(index, "remark", "");
                    }
                    this.$set(index, "showRemark", false);
                    this.$set(index, "showPop", false);
                    this.$set(index, "showDia", false);
                    this.$set(index, "newOrderQty", index.orderQty);
                    this.$set(index, "newRemark", index.remark);
                  });
                });
              } else {
                this.CartList = [];
              }
            });
        });
    },
    // 单规格输入
    DiaDan(rs) {
      let far = this.CartList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.showDia = true;
      son.newOrderQty = son.orderQty;
    },
    // 单规格添加
    DanAdd(rs) {
      let far = this.CartList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.havingCartInfo = true;
      son.orderQty = 1;
      son.showRemark = true;
    },
    // 单规格删除全部
    DanAllRem(rs) {
      let far = this.CartList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.havingCartInfo = 0;
      son.orderQty = 0;
      son.showRemark = false;
    },
    // 多规格数量输入
    Dia(rs) {
      let far = this.CartList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.showDia = true;
      son.newOrderQty = son.orderQty;
    },
    // 多规格显示备注
    sPop(rs) {
      let far = this.CartList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.newRemark = son.remark;
      son.showPop = true;
    },
    // 单规格显示备注
    sPopDan(rs) {
      let far = this.CartList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.showPop = true;
      son.newRemark = son.remark;
    },
    addition() {},
    // 显示进步器
    JiBu(rs) {
      let far = this.CartList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.havingCartInfo = 1;
      son.orderQty = 1;
      son.showRemark = true;
    },
    // 添加备注
    addRemark(rs) {
      let far = this.CartList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.remark = rs[2];
    },
    // 删除所有商品
    removeAll(rs) {
      let far = this.CartList.find((item) => {
        return item.goodsId == rs[1];
      });
      let son = far.children.find((item) => {
        return item.skuId == rs[0];
      });
      son.havingCartInfo = 0;
      son.orderQty = 0;
      son.showRemark = false;
    },
    // 显示规格列表
    showGuige(id) {
      let guige = this.CartList.find((item) => item.goodsId == id);

      guige.showGuiGe = !guige.showGuiGe;
    },
    onConfirm() {
      this.$refs.item.toggle();
    },
    // 获取商品子类
    getChildrenLits(val) {
      this.activeKey = 0;
      // 新增 解决当选了二级有菜单的分类后再选择没有二级菜单的分类时上一次选择的二级菜单还会展示；
      this.CartList = [];
      this.finished = false

      localStorage.setItem("categoryId", val);
    },
    onChange(index) {
      this.categoryIndex = index;
    },
    // 转跳到搜索页
    goSearch() {
      localStorage.removeItem("searchValue");
      this.$router.push("/search");
    },
    // 转调至购物车页
    goCart() {
      this.$router.push("/cart");
    },
    // 去分类页
    goCate() {
      window.history.back();
    },
  },
};
</script>

<style lang='scss' scoped>
.classify {
  background: rgba(237, 237, 237, 1);
  position: relative;
  padding-top: 40px;
}
.cla-sidebar {
  /* position: absolute !important; */
  top: 80px;
}
.class_van_drop {
  position: fixed;
  top: 40px;
  width: 100%;
  z-index: 999;
}
header {
  position: fixed;
  padding-left: 30px;
  top: 0;
  width: 100% !important;
  z-index: 999;
  background-color: rgba(237, 237, 237, 1);
}
.header {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 40px;
  color: rgba(102, 102, 102, 1);
}
.i {
  position: absolute;
  top: 13px;
  left: 10px;
}
.van-sidebar-item--select {
  border-color: rgba(116, 180, 43, 1);
  background-color: rgba(237, 237, 237, 1);
}
/deep/ .van-sidebar-item--select::before {
  background-color: rgba(116, 180, 43, 1);
}
.van-sidebar-item {
  padding: 10px 10px;
}
.van-sidebar-item--disabled {
  color: rgba(116, 180, 43, 1);
  font-weight: 500;
}
.van-sidebar {
  position: fixed;
  height: 100%;
  background-color: #fff;
}
.van-dropdown-menu {
  height: 40px;
}
.van-ellipsis {
  color: rgba(116, 180, 43, 1);
}
.search {
  position: absolute;
  right: 13%;
  top: 15%;
  z-index: 999;
}
.shopping-cart {
  position: absolute;
  right: 5%;
  top: 15%;
  z-index: 999;
}
.van-sidebar-item {
  background-color: #fff;
}
.van-sidebar-item--select {
  background-color: rgba(237, 237, 237, 1);
}
.van-sidebar {
  height: 100%;
  z-index: 2;
}
.van_down {
  position: absolute;
  left: 58%;
  top: 31%;
}
.active {
  left: 65%;
}

.van-icon-arrow-left {
  top: 11.5px;
  left: -9px;
}
.loading {
  position: fixed;
  left: 58%;
  top: 40%;
  transform: translate(-50%, -50%);
}
.noLists {
  position: fixed;
  left: 60%;
  top: 40%;
  transform: translate(-50%, -50%);
  z-index: 1;
  scale: 0.8;
}
.search-p {
  /* padding-left: 50px; */
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  text-align: center;
  width: 100%;
}
/deep/ .van-dropdown-menu__bar {
  height: 40px;
}
</style>